module.exports = __webpack_public_path__ + "assets/icons/chat-icon-new-messages.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/chat/chat-icon-new-messages.png
// module id = ./src/styles/icons/chat/chat-icon-new-messages.png
// module chunks = 0